import Splide from "@splidejs/splide";
import { Grid } from "@splidejs/splide-extension-grid";
import { Intersection } from "@splidejs/splide-extension-intersection";

/**
 * Splide Gallery
 * .--two-rows : 2 lignes en desktop, 1 ligne en mobile loop
 */
function initSplideGallery(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;

	const galleries = root.querySelectorAll(".splide-gallery");

	galleries.forEach((gallery) => {
		const isTwoRows = gallery.classList.contains("--two-rows");

		const config = {
			type: "loop",
			gap: "27px",
			pagination: false,
			arrows: true,
			snap: false,
			autoplay: "pause",
			pauseOnHover: true,
			intersection: {
				inView: {
					autoplay: true,
				},
				outView: {
					autoplay: false,
				},
			},
			interval: 6000,
			speed: 700,
			focus: 0,
			omitEnd: true,
			padding: "7.5%",
		};

		if (isTwoRows) {
			// if (!editor) {
				// désactivation en grid dans l'editeur
				// car si on supprime une image,le bloc se casse car grid change la structure du DOM et gutenberg ne sait plus trouver les éléments à supprimer

				config.perPage = 3;
				config.grid = {
					rows: 2,
					cols: 1,
					gap: { row: "27px", col: "27px" },
				};
				config.breakpoints = {
					1024: {
						perPage: 2,
						gap: "20px",
						grid: {
							rows: 2,
							cols: 1,
							gap: { row: "20px", col: "20px" },
						},
					},
					640: {
						padding: "7.5vw",
						perPage: 1,
						gap: "16px",
						grid: false,
					},
				};
			// }
		} else {
			config.autoWidth = true;
			config.breakpoints = {
				1024: { gap: "20px" },
				640: {
					padding: "7.5vw",
					// perPage: 1,
					focus: "center",
					gap: "16px",
				},
			};
		}

		const extensions = isTwoRows ? { Grid, Intersection } : { Intersection };
		const splideGallery = new Splide(gallery, config);
		splideGallery.mount(extensions);

	
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSplideGallery());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-gallery", ($block) => {
		initSplideGallery($block && $block.jquery ? $block.get(0) : $block);
	});
}
